// extracted by mini-css-extract-plugin
export default {"tvBlock":"_1_tv-block_tvBlock__pGiby","tv":"_1_tv-block_tv__I8sqi","glow":"_1_tv-block_glow__-PbTV","glowRed":"_1_tv-block_glowRed__Nb4mc","glowLight":"_1_tv-block_glowLight__uwNG3"};